import { Flex, SubText } from "@base-ui";
import { DevelopmentBannerHolder, InlineLink } from "./developmentBanner.styles";

/** Beta site URL (adjust if the preview is hosted elsewhere). */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BETA_SITE_URL = "https://beta.vardenisiffror.se";
export default function DevelopmentBanner() {
  return /*#__PURE__*/_jsx(Flex.Row, {
    style: {
      zIndex: "999",
      position: "sticky",
      top: 0
    },
    children: /*#__PURE__*/_jsx(DevelopmentBannerHolder, {
      children: /*#__PURE__*/_jsxs(SubText, {
        role: "alert",
        style: {
          margin: 0,
          textAlign: "center",
          color: "#000000"
        },
        children: ["Vi utvecklar V\xE5rden i siffror! Nu kan du", " ", /*#__PURE__*/_jsx(InlineLink, {
          href: BETA_SITE_URL,
          target: "_blank",
          rel: "noopener noreferrer",
          style: {
            color: "#000000"
          },
          "aria-label": "testa betaversionen h\xE4r (\xF6ppnas i ny flik)",
          children: "testa betaversionen h\xE4r"
        }), "."]
      })
    })
  });
}